import { createMemoryHistory, createRouter, createWebHistory } from 'vue-router'
import { type RouterOptions } from 'vue-router'
import HomeView from '../views/home/HomeView.vue'
import Config from '@/utils/config'

const router = createRouter({
  history: Config.ssr
    ? createMemoryHistory(import.meta.env.BASE_URL)
    : createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:locale(.{2})?',
      children: [
        {
          path: '',
          name: 'home',
          component: HomeView
        },
        {
          path: 'appointment',
          name: 'appointment',
          component: () => import('../views/AppointmentView.vue')
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('../views/ContactView.vue')
        },
        {
          path: 'demo',
          name: 'demo',
          component: HomeView
        },
        {
          path: 'imprint',
          name: 'imprint',
          component: () => import('../views/content/ImprintView.vue')
        },
        {
          path: 'pricing',
          name: 'pricing',
          component: () => import('@/views/content/PricingView.vue')
        },
        {
          path: 'products/:product?',
          name: 'products',
          component: () => import('../views/products/ProductsView.vue')
        },
        {
          path: 'resources',
          name: 'resources',
          component: () => import('../views/resources/ResourcesView.vue')
        },
        {
          path: 'solutions/:industry?',
          name: 'solutions',
          component: () => import('../views/solutions/SolutionsView.vue')
        },
        {
          path: 'support',
          name: 'support',
          component: () => import('../views/content/SupportView.vue')
        },
        {
          path: 'terms',
          name: 'terms',
          component: () => import('../views/content/TermsView.vue')
        },
      ],
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    const scrollContainer = document.querySelector('.scroll-container');
    if (!scrollContainer) return savedPosition ?? { left: 0, top: 0 }

    if (savedPosition) {
      scrollContainer.scrollTo(savedPosition)
      return false
    }

    if (to.hash && document) {
      const el = document.getElementById(to.hash)
      if (el) {
        el.scrollIntoView()
        return false
      }
    }

    scrollContainer.scrollTo({ left: 0, top: 0 })

    return false
  },
} as RouterOptions)

export default router
